import Vue from "vue";
import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';

export default {
  namespaced: true,
  state: {
    users: [],
    fetched: false,
    user: {
      all_rights: {},
      extra_rights: {},
      all_roles: {},
      shops: [],
      profile_photo: null,
      profile_photo_blob: null,
      profile_photo_data_url: null,
    },
    roles: [],
    extra_rights: {},
    savingInProgress: false,
    isLoadingProfilePhoto: false,
  },
  getters:{
    getField, //vuex-map-fields
    getUserById: state => id => {
      return state.users[Number(id)];
    }
  },
  mutations: {
    updateField, //vuex-map-fields
    setUsers(state, users) {
      state.users = users;
      state.fetched = true;
    },
    setUserById(state, id) {
      let user = Object.entries(state.users).filter(user => Number(user[1].id)===Number(id))
      if(user.length) {
        state.user = user[0][1];
        state.fetched = true;
      } else {
        state.user = null;
        state.fetched = true;
      }
    },
    setNewUser(state){
      state.user = {
        id: null,
        name:'',
        extra_rights:{},
        all_rights:{},
        all_roles:[]
      };
      state.fetched = true;
    },
    addUserToState(state, data){
      let object = state.users;
      object.push(data);
      Vue.set(state, 'users', object);
      state.fetched = true;
    },
    removeUserFromState(state, id){
      state.users.splice(state.users.findIndex((o)=>parseInt(o.id)===parseInt(id)), 1)
      state.fetched = true;
    }
  },
  actions: {
    async get({ commit, state, dispatch }){
      updateField(state, {path:'fetched', value:false});
      return await axios.get(this._vm.$apiURL+'/users')
        .then(response => {
          commit('setUsers', response.data || null);
        })
        .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'fetched', value:true});
        })
    },
    async update({ commit, state, dispatch }){
      updateField(state, {path:'savingInProgress', value:true});
      return await axios.put(this._vm.$apiURL+'/users/'+state.user.id,
            state.user
          )
          .then(response => {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
            return true;
          })
          .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
            return false;
          })
          .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
          })
    },
    async remove({ commit, state, dispatch }, payload){
      this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('common.confirm_remove'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( async y =>{
        return await axios.delete(this._vm.$apiURL+'/users/'+payload.id,
            {
              id:payload.id
            })
            .then(response => {
              if(response.data.status==='success'){
                commit('removeUserFromState', payload.id);
                this._vm.$inform( this._vm.i18n.t('common.success_remove') )
              }
            })
            .catch(error => {
              dispatch('common/showError', {'error': error}, {root:true});
            });

      } ).catch( n => {

      } );
    },
    async create({ commit, state, dispatch }){
      updateField(state, {path:'savingInProgress', value:true});
      return await axios.post(this._vm.$apiURL+'/users', state.user)
          .then(response => {
            if(response.data.id){
              commit('addUserToState', response.data.new);
              this._vm.$inform( this._vm.i18n.t('common.success_add'));
              return response.data.id;
            }
          })
          .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
          })
          .finally(()=>{
              updateField(state, {path:'savingInProgress', value:false});
          })
    },
    getUserById(context, payload){
      if(!context.state.users.length){
        return context.dispatch('get').then(()=>{
          context.commit('setUserById', payload.id || null);
        })
      } else {
        context.commit('setUserById', payload.id || null);
      }
    },
    getNewUser(context, payload){
      context.commit('setNewUser');
    },
    changeCurrentUserPassword({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:true});
      return axios.post(this._vm.$apiURL+'/users/change-password',
        {
            password: payload
        })
        .then(response => {
          if(response.data.status === 'success') this._vm.$inform( this._vm.i18n.t('common.operation_success'));
            return true;
        })
        .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
            return false;
        })
        .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    async changeCurrentUserTheme({ commit, state, dispatch }, payload){
        updateField(state, {path:'savingInProgress', value:true});
        return await axios.post(this._vm.$apiURL+'/users/change-theme',
            {
                theme: payload
            })
            .then(response => {
                if(response.data.status === 'success') this._vm.$inform( this._vm.i18n.t('common.operation_success'));
                return response.data.theme;
            })
            .catch(error => {
                dispatch('common/showError', {'error': error}, {root:true});
                return false;
            })
            .finally(()=>{
                updateField(state, {path:'savingInProgress', value:false});
            })
    },
    async setUserProfilePhoto({ commit, state, dispatch }, payload){
        updateField(state, {path:'isLoadingProfilePhoto', value:true});
        let formData;
        if(payload.blob) {
            formData = new FormData();
            formData.append('image', payload.blob, 'name.jpeg');
        } else {
            formData = {
                image:null
            }
        }
        return await axios.post(this._vm.$apiURL+`/users/${payload.userId}/profile-photo`, formData)
            .then(response => {
                if(response.data.status === 'success') this._vm.$inform( this._vm.i18n.t('common.operation_success'));
                return response.data;
            })
            .catch(error => {
                dispatch('common/showError', {'error': error}, {root:true});
                return false;
            })
            .finally(()=>{
                updateField(state, {path:'isLoadingProfilePhoto', value:false});
            })
    },

  }
}



